import { DestroyRef, Directive, ElementRef, inject, Input } from '@angular/core';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[cxNumbersInputOnly]',
  standalone: true
})
export class NumbersInputOnlyDirective {

  @Input() excludesChars: string[] = ['.', ','];

  public isContentEditable = false;

  private readonly _el = inject(ElementRef<HTMLElement & HTMLInputElement>);
  private readonly _destroyRef = inject(DestroyRef);

  public constructor() {
    this.isContentEditable = this._el.nativeElement.getAttribute('contenteditable') !== null;
    fromEvent(this._el.nativeElement, 'input').pipe(
      takeUntilDestroyed(this._destroyRef),
    ).subscribe(this.onInputChange.bind(this));
  }

  private onInputChange(event): void {
    const initialValue = this.value;
    const excludedCharsPattern = this.excludesChars.map(char => this.escapeRegex(char)).join('');
    const regexPattern = `[^0-9${excludedCharsPattern}]*(?=[^${excludedCharsPattern}]*$)`;
    const newVal = initialValue.replace(new RegExp(regexPattern, 'g'), '');

    this.isContentEditable ? this._el.nativeElement.textContent = newVal : this._el.nativeElement.value = newVal;

    if (initialValue !== this.value) {
      event.stopPropagation();
    }
  }

  private get value(): string {
    return this.isContentEditable ? this._el.nativeElement.textContent : this._el.nativeElement.value;
  }

  private escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
